"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultQuestionImgSrc = void 0;
var defaultQuestionImgSrc = 'https://dotaudiences.com/dot-default-scenery.jpg';
exports.defaultQuestionImgSrc = defaultQuestionImgSrc;